import PageLayer from "@/Layouts/views/PageLayer";
import AdministrationToolsContainer from "@/Settings/components/AdministrationTools/AdministrationToolsContainer";
import AdministrationToolsIcon from "@/assets/icons/settings/adminTools.svg";

export default function AdministrationTools() {
	return (
		<PageLayer title="Administration Tools" icon={AdministrationToolsIcon}>
			<AdministrationToolsContainer />
		</PageLayer>
	);
}
